import script from './component-lib.esm3.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Input', _vm._b({
    ref: "input",
    on: {
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      },
      "focus": function ($event) {
        _vm.setSelection, _vm.$emit('focus', $event);
      },
      "input": _vm.setSelection
    },
    model: {
      value: _vm.localValue,
      callback: function ($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  }, 'Input', Object.assign({}, _vm.$props, _vm.$attrs), false), [_c('template', {
    slot: "prepend"
  }, [_vm._t("prepend")], 2), _vm._v(" "), _vm.showEmoji ? _c('IconButton', {
    ref: "trigger",
    attrs: {
      "slot": "append",
      "aria-label": "Select emoji",
      "disabled": _vm.disabled,
      "loading": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        _vm.showPicker = !_vm.showPicker;
      }
    },
    slot: "append"
  }, [_c('SmileOIcon')], 1) : _vm._e()], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-340ba2a6";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };